





















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class InputSelect extends Vue {
	internalValue: string | object | null = null;

	@Prop({ required: true })
	value!: any;

	@Prop({ type: String, required: true })
	name!: string;

	@Prop({ type: String, required: false, default: '' })
	label!: string;

	@Prop({ type: String, required: false, default: '#000' })
	color!: string;

	@Prop({ type: [String, Object], required: false, default: '' })
	rules!: string | object;

	@Prop({ type: Boolean, required: false, default: true })
	showErrors!: boolean;

	@Prop({ type: Boolean, required: false, default: false })
	hideTopMargin!: boolean;

	@Prop({ type: Boolean, required: false, default: false })
	small!: boolean;

	get id() {
	    return this.name + new Date().valueOf();
	}

	created() {
	    this.internalValue = this.value;
	}

	@Watch('value')
	onValueChange(value: object) {
	    this.internalValue = value;
	}

	@Watch('internalValue')
	onInternalValueChange(value: any) {
	    this.$emit('input', value);
	    this.$emit('change', value);
	}

	get listeners() {
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    const { change, input, ...listeners } = this.$listeners;
	    return listeners;
	}

	get hasValue(): boolean {
	    return !!this.value;
	}
}
